var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIssuersActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3565_22483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1667 17.5002H18.3333V10.8335H16.6667V17.5002H13.3333V10.8335H11.6667V17.5002H8.33333V10.8335H6.66667V17.5002H3.33333V10.8335H1.66667V17.5002H0.833333C0.373333 17.5002 0 17.8727 0 18.3335C0 18.7943 0.373333 19.1668 0.833333 19.1668H19.1667C19.6267 19.1668 20 18.7943 20 18.3335C20 17.8727 19.6267 17.5002 19.1667 17.5002Z",
    fill: "#4F8CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5658 5.10174L10.3992 0.101738C10.15 -0.0332617 9.85 -0.0332617 9.60083 0.101738L0.434167 5.10174C0.166667 5.24757 0 5.5284 0 5.8334V8.3334C0 8.79424 0.373333 9.16674 0.833333 9.16674H19.1667C19.6267 9.16674 20 8.79424 20 8.3334V5.8334C20 5.5284 19.8333 5.24757 19.5658 5.10174ZM10 6.66674C9.07917 6.66674 8.33333 5.9209 8.33333 5.00007C8.33333 4.07924 9.07917 3.33341 10 3.33341C10.9208 3.33341 11.6667 4.07924 11.6667 5.00007C11.6667 5.9209 10.9208 6.66674 10 6.66674Z",
    fill: "#001350"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3565_22483"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssuersActive);
export default __webpack_public_path__ + "static/media/issuers-active.3bd4822a91ccabd3b01fc55c6ac90127.svg";
export { ForwardRef as ReactComponent };